<template>
  <v-container>
    <BackButton path="/" />

    <AdminViewTitle />

    <AdminLines />
  </v-container>
</template>

<script>
import BackButton from '@/components/BackButton'
import AdminLines from '@/components/adminVideo/AdminLines'
import AdminViewTitle from '@/components/adminVideo/AdminViewTitle'

import { mapGetters, mapState } from 'vuex'

export default {
  name: 'AdminVideo',

  computed: {
    ...mapState({
      configurations: state => state.adminVideo.configurations
    }),
    ...mapGetters(['userId'])
  },

  components: {
    AdminViewTitle,
    AdminLines,
    BackButton
  },

  async created() {
    await this.$store.dispatch('adminVideo/getAdminVideoConfigurations', this.userId)
  },

  data() {
    return {
      introductionVideoUrl: null,
      conclusionVideoUrl: null,
      audioUrl: null
    }
  }
}
</script>

<style lang="sass" scoped>
.center-block
  margin: 0 auto
</style>
